module.exports = __webpack_public_path__ + "static/media/SheJiao4.99bb9986.png";